<template>
    <div class="global-search__results">
        <template v-if="searchResponse">
            <div class="global-search__shortcuts" v-if="shortcuts && resultSetSetting === resultKinds.all">
                <global-quicksearch-shortcut v-for="(shortcut, key) in shortcuts"
                                             :shortcut="shortcut"
                                             :key="key" />
            </div>

            <template v-if="searchResponse.boards && (resultSetSetting === resultKinds.all || resultSetSetting === resultKinds.boards)">
                <template v-if="searchResponse.boards.resultCount">
                    <search-result-set :result-set="searchResponse.boards"></search-result-set>
                </template>
            </template>

            <template v-if="searchResponse.decor && (resultSetSetting === resultKinds.all || resultSetSetting === resultKinds.decor)">
                <template v-if="searchResponse.decor.resultCount">
                    <search-result-set :result-set="searchResponse.decor"></search-result-set>
                </template>
            </template>

            <template v-if="searchResponse.structure && (resultSetSetting === resultKinds.all || resultSetSetting === resultKinds.structure)">
                <template v-if="searchResponse.structure.resultCount">
                    <search-result-set :result-set="searchResponse.structure"></search-result-set>
                </template>
            </template>

            <template v-if="searchResponse.reference && (resultSetSetting === resultKinds.all || resultSetSetting === resultKinds.reference)">
                <template v-if="searchResponse.reference.resultCount">
                    <search-result-set :result-set="searchResponse.reference"></search-result-set>
                </template>
            </template>

            <template v-if="searchResponse.downloads && (resultSetSetting === resultKinds.all || resultSetSetting === resultKinds.downloads)">
                <template v-if="searchResponse.downloads.resultCount">
                    <search-result-set :result-set="searchResponse.downloads"></search-result-set>
                </template>
            </template>

            <template v-if="searchResponse.page && (resultSetSetting === resultKinds.all || resultSetSetting === resultKinds.page)">
                <template v-if="searchResponse.page.resultCount">
                    <search-result-set :result-set="searchResponse.page"></search-result-set>
                </template>
            </template>

        </template>
    </div>
</template>

<script>
    import SearchResultSet from "../search-result-set/search-result-set.vue";
    import SearchLoading from "../search-loading/search-loading.vue";
    import constants from "../../shared/constants";
    import GlobalQuicksearchShortcut
      from "@global/global-elements/global-quicksearch/components/global-quicksearch-shortcut/global-quicksearch-shortcut";

    export default {
        name: "search-results",
        components: {GlobalQuicksearchShortcut, SearchLoading, SearchResultSet},
        data() {
            return {
                searchQueryNumber: null,
                searchQueryOffset: null,
                keyword: null,
            }
        },
        computed: {
            resultKinds () {
                return constants.resultKind
            },
            localization () {
                return this.$store.getters.localize
            },
            resultSetSetting () {
                return this.$store.state.category
            },
          shortcuts () {
              return this.$store.getters.shortcuts
          },
			searchResponse() {
            	return this.$store.getters.searchResults;
			}
        }
    }
</script>

